(ns frontend.view.modals.entry-criteria.model)

(defonce modal-key :entry-criteria-modal)
